/**
 * Copyright SweetCode. All rights reserved.
 *
 * Load VWO event listeners
 * */

// Pixel load event listener
pmw.bus.on("pmw:load-pixels", () => {

	if (pmwDataLayer?.pixels?.vwo?.account_id && !pmwDataLayer?.pixels?.vwo?.loaded) {
		if (pmw.consent.canPixelBeFired("statistics", "VWO")) pmw.loadVwoPixel()
	}
})

// view order received page event
pmw.bus.on("pmw:pixel:purchase", (payload) => {

	try {
		if (!pmw.shouldFireBrowserPixel(payload, "vwo")) return
		if (pmw.canNotFireVwoEvent()) return

		const vwoData = payload.pixels?.vwo;
		if (!vwoData) return;

		const data = [vwoData.event_type, vwoData.revenue_value];

		// Needs the catch: a blocked or unconfigured VWO rejects, and without it
		// every conversion event raised an unhandled promise rejection.
		pmw.vwoLoaded().then(() => {
			window.VWO.push(data)
			pmw.console.log("VWO Pixel: track.revenueConversion event sent", data)
		}).catch(e => {
			pmw.console.error("VWO Pixel: event not sent.", e && e.message ? e.message : e)
		})

	} catch (e) {
		console.error(e)
	}
})

